export const parseServerError = (error) => {
    const replaceRegEx = /\{([0-9]+)\}/gi;
    return error.message.replace(replaceRegEx, (matched, digit) => error.arguments[digit]);
};
export function createAPIError(key, message, args = []) {
    return {
        key,
        message,
        arguments: args,
    };
}
export function handleAxiosError(error) {
    if (isAxiosResponse(error))
        throw error.data;
    else
        throw error;
}
function isAxiosResponse(error) {
    return Object.keys(error).includes('status');
}
export function isAPIErrorList(error) {
    if (Array.isArray(error) && error.length > 0) {
        return isAPIError(error[0]);
    }
    else
        return false;
}
export function isAPIError(error) {
    const keys = Object.keys(error);
    return (keys.includes('key') &&
        keys.includes('message') &&
        keys.includes('arguments'));
}
export function isError(error) {
    return (typeof error === 'object' &&
        Object.getOwnPropertyNames(error).includes('message'));
}
